export enum CustomsPerformanceMetricsName {
  // common api like：account、cdn、TCC
  CommonAPIsStart = 'performance: common_apis_start',
  CommonAPIsEnd = 'performance: common_apis_end',
  CommonAPIsDuring = 'performance: common_apis_during',
  // i18n api cost
  I18nAPIsStart = 'performance: i18n_apis_start',
  I18nApisEnd = 'performance: i18n_apis_end',
  I18nApisDuring = 'performance: i18n_apis_during',
  // js of sub-app cost, sub app is /product
  LoadSubAppStart = 'performance: render_sub_app_start',
  LoadSubAppEnd = 'performance: render_sub_app_end',
  LoadSubAppDuring = 'performance: render_sub_app_during',
  // the cost of the sub-page within the sub-app
  BizJsStart = 'performance: biz_js_start',
  BizJsEnd = 'performance: biz_js_end',
  BizJsDuring = 'performance: biz_js_during',
  // the api/js cost of the sub-page within the sub-app
  BizAPIsStart = 'performance: biz_apis_start',
  BizAPIsEnd = 'performance: biz_apis_end',
  BizAPIsDuring = 'performance: biz_apis_during',
}
